import { getTemplateLOTO } from "@/pages/templates/repositories/TemplatesRepositorie";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { get } from "lodash-es";

type Props = {
	setIsTemplateLOTOLoading: (isLoading: boolean) => void;
	setTemplateLOTOError: (err: string) => void;
	TemplateId: number | null;
};

export const useSearchTemplateLOTO = ({
	TemplateId,
	setIsTemplateLOTOLoading,
	setTemplateLOTOError,
}: Props) => {
	const {
		actions: { setTemplateLOTOList },
	} = useTemplatesContext();

	return async () => {
		setTemplateLOTOList([]);
		setIsTemplateLOTOLoading(true);
		const res = await getTemplateLOTO(TemplateId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setTemplateLOTOList(rowsSource);
			setIsTemplateLOTOLoading(false);
		} else {
			setIsTemplateLOTOLoading(false);
			setTemplateLOTOError(res.message);
		}
	};
};
